module.exports = __webpack_public_path__ + "img/canals5d-expert-mode@2x.7b14714f.jpg";